import React from 'react';

interface LockProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Lock: React.FC<LockProps> = ({ width = 20, height = 20, className, style }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" className={className} style={style}>
      <rect
        x="3"
        y="11"
        width="18"
        height="11"
        rx="2"
        ry="2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 11V7a5 5 0 0 1 10 0v4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Lock;
